import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const DeleteForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="deleteFormAction"
        label="action"
        name="action"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        required
        error={errors?.action?.message}
        defaultValue="DELETE"
      />

      <FormField
        controlId="deleteFormCommand"
        label="command"
        name="command"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        error={errors?.command?.message}
        defaultValue="DELETE"
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default DeleteForm;
